import createClient from "openapi-fetch"
import type { paths } from "../utils/schema"
import { AppErrors, handleAppError } from "../utils/error"
import { AppError } from "../utils/error"
import { useUserStore } from "../stores/user"

const handleUnauthorized = async () => {
  const userStore = useUserStore()
  userStore.setUser(undefined, undefined)
}

const customFetchWithInterceptor = async (
  input: URL | RequestInfo,
  init?: RequestInit | undefined
) => {
  const response = await fetch(input, init)

  try {
    if (response.status === 401) {
      throw new AppError(AppErrors.ApiClientUnauthorized)
    } else if (!response.ok) {
      throw new AppError(AppErrors.ApiClientRequest)
    }
  } catch (error) {
    handleAppError(error, new AppError(AppErrors.ApiClient))
  } finally {
    if (response.status === 401) {
      await handleUnauthorized()
    }
  }
  return response
}

export const useClient = () => {
  const userStore = useUserStore()
  const token = userStore?.token

  return createClient<paths>({
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    baseUrl: import.meta.env.VITE_API_BASE_URL,
    fetch: customFetchWithInterceptor as typeof createClient.prototype.fetch
  })
}
